import React, { createContext, useContext } from 'react';
import Box from '@mui/material/Box';

/**
 * reactstrap's TabContent/TabPane pair, without reactstrap.
 *
 * Kept rather than swapped for conditional rendering because these panes are redux-form: every
 * pane stays mounted and the inactive ones are only hidden, so a Field never unregisters — and
 * its validation never silently stops running — just because the user looked at another tab.
 */
const ActiveTabContext = createContext(undefined);

export function TabContent({ activeTab, children, ...rest }) {
  return (
    <ActiveTabContext.Provider value={activeTab}>
      <Box {...rest}>{children}</Box>
    </ActiveTabContext.Provider>
  );
}

export function TabPane({ tabId, children }) {
  const activeTab = useContext(ActiveTabContext);
  return (
    <Box role='tabpanel' hidden={activeTab !== tabId}>
      {children}
    </Box>
  );
}
